// extracted by mini-css-extract-plugin
module.exports = {"box":"Dots-box-89b0","dot":"Dots-dot-89b0","active":"Dots-active-89b0"};